import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import ProTreeDetail from "@/components/Tree/pro-tree-app-detail.vue";
export default {
  name: "app-detail-point-modal",
  components: {
    ProTreeDetail
  },
  props: {
    tissue: {
      type: String,
      default() {
        return $t("pgxs2", "部门");
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      treeData: [],
      search: {
        value: ""
      },
      originType: "",
      rowItem: {}
    };
  },
  computed: {
    // 已选数据
    _selectList() {
      let treeData = [];
      let change = arr => {
        arr.forEach(v => {
          if (v.webChecked) {
            treeData.push(v);
          }
          let children = v.children;
          if (children && children.length > 0) {
            change(children);
          }
        });
      };
      change(this.treeData);
      return treeData;
    }
  },
  methods: {
    close() {
      this.rowItem = {};
      this.originType = "";
      this.search.value = "";
      this.treeData = [];
      this.modal.loading = false;
      this.modal.visible = false;
    },
    open(treeData, item, type) {
      this.modal.visible = true;
      this.originType = type;
      this.rowItem = {
        ...item
      };
      // 弹窗维护独立树状态，避免取消选择或切换节点时污染外层接口数据。
      this.treeData = JSON.parse(JSON.stringify(treeData || []));
    },
    // 右侧列表使用业务标识作为 key，确保切换选中项时 DOM 与数据同步。
    getNodeKey(item, index) {
      return item.key || item.uuid || item.unitCode || item.code || item.id || index;
    },
    /*
     * 去除选中
     */
    onDelete(item) {
      // webChecked 可能是接口数据中不存在的字段，必须通过 $set 保持 Vue 2 响应式。
      this.$set(item, "webChecked", false);
    },
    /*
     * 当前接口状态
     */
    setLoading(boo) {
      this.modal.loading = boo;
    },
    onCommit() {
      this.$emit("on-submit-bind", this._selectList, this.rowItem, this.originType);
    }
  }
};